export enum ReportsReportViewerEnum {
  MarketAnalysis = 16,
  MarketAnalysisProductsActingArea = 17,
  MarketAnalysisProductsOperational = 18,
  MarketEvolution = 19,
  DealerMarketShare = 25,
  PerformanceSalesAnnual = 32,
  FordDealerPerformance = 33,
  PerformanceSegmentContractualArea = 34,
  PerformanceSegmentRegionalsNational = 35,
}
